import {
  DEFAULT_TEAM_TYPE_PREFERENCE_MAP as JOB_SEEKER_PREFERENCE,
  NONE_TEAM_TYPE_PREFERENCE,
  TEAM_TYPE_MODULE_SENTENCE as JOB_SEEKER_TEAM_MODULE_SENTENCE,
  MODULE_SENTENCE as JOB_SEEKER_MODULE_SENTENCE,
  CULTURE_PREFERENCE_TEXT,
  CULTURE_PREFERENCE_TEXT_OPTION,
} from '@/constants/profile-builder';
import {
  DEFAULT_TEAM_TYPE_PREFERENCE_MAP as EMPLOYER_PREFERENCE,
  TEAM_TYPE_MODULE_SENTENCE as EMPLOYER_TEAM_MODULE_SENTENCE,
  MODULE_SENTENCE as EMPLOYER_MODULE_SENTENCE,
} from '@/constants/job-builder';
import { STORAGE_NAME } from '@/components/wenhua/QuizQuestion';
import {
  CULTURE_PREFERENCE,
  CULTURE_PREFERENCE_CHOICES,
  CULTURE_PREFERENCE_SCORE,
  CULTURE_PREFERENCE_TYPE,
} from '@/context/job-builder';
import { getLocalStorage, removeLocalStorage } from '@/utils/storage';
import { updateJobSeekerProfile } from '@/api/tanzhi';
import AdhocracyIcon from '@/assets/profile-builder/adhocracy.svg';
import ClanIcon from '@/assets/profile-builder/clan.svg';
import HierarchyIcon from '@/assets/profile-builder/hierarchy.svg';
import MarketIcon from '@/assets/profile-builder/market.svg';
import NoResultIcon from '@/assets/profile-builder/unknown.svg';
import AdhocracyBriefIcon from '@/assets/candidate-builder/adhocracy.svg';
import MarketBriefIcon from '@/assets/candidate-builder/market.svg';
import HierarchyBriefIcon from '@/assets/candidate-builder/hierarchy.svg';
import ClanBriefIcon from '@/assets/candidate-builder/clan.svg';

export const getCulturePreferenceResult = (data: number[][]) => {
  const scoreObj = { ...defaultScoreObj };

  data?.map((item, index) => {
    const findIndex = item.findIndex((value) => value === 1);
    if (findIndex > -1 && findIndex < 2) {
      const selectedKey = CULTURE_PREFERENCE_TEXT_OPTION[index][findIndex];
      scoreObj[selectedKey as keyof typeof scoreObj] += 1;
    }
  });

  const xAxisScore = Object.values(scoreObj).slice(0, 2);
  const yAxisScore = Object.values(scoreObj).slice(2);
  const areaObj = {
    A: xAxisScore[0] * yAxisScore[0],
    C: xAxisScore[1] * yAxisScore[0],
    H: xAxisScore[1] * yAxisScore[1],
    M: xAxisScore[0] * yAxisScore[1],
  };
  const sortAreaObjKeys = Object.keys(areaObj).sort(
    (k1, k2) => Reflect.get(areaObj, k2) - Reflect.get(areaObj, k1),
  );

  const isXAxisMultiCase =
    (xAxisScore.includes(6) && xAxisScore.includes(9)) ||
    (xAxisScore.includes(7) && xAxisScore.includes(8));
  const isYAxisMultiCase =
    (yAxisScore.includes(6) && yAxisScore.includes(9)) ||
    (yAxisScore.includes(7) && yAxisScore.includes(8));

  const _teamTypePreference =
    sortAreaObjKeys
      .slice(
        0,
        (isXAxisMultiCase && isYAxisMultiCase) ||
          (!isXAxisMultiCase && !isYAxisMultiCase)
          ? 1
          : 2,
      )
      .join('') || '';
  const _teamTypePreferenceScore = Reflect.get(areaObj, sortAreaObjKeys[0]);

  return {
    _teamTypePreference,
    _teamTypePreferenceScore,
    _culturePreferenceScore: scoreObj,
  };
};

export const configData: Record<string, any> = {
  A: {
    desc: 'A型 (Adhocracy) - 专业探索型',
    briefDesc: '专业探索型',
    icon: AdhocracyIcon,
    keyWords: '专业、创新、灵活',
    coreStatement: '专业的指导与决策，工作与生活平衡',
  },
  M: {
    desc: 'M型 (Market) - 任务竞争型',
    briefDesc: '任务竞争型',
    icon: MarketIcon,
    keyWords: '压力、竞争、挑战',
    coreStatement: '喜爱高目标挑战从而获得高收益的过程',
  },
  H: {
    desc: 'H型 (Hierarchy) - 精细流程型',
    briefDesc: '精细流程型',
    icon: HierarchyIcon,
    keyWords: '严谨、集体制、流程化',
    coreStatement: '重度细节控、高执行力',
  },
  C: {
    desc: 'C型 (Clan) - 友善协作型',
    briefDesc: '友善协作型',
    icon: ClanIcon,
    keyWords: '温情、合作、稳定',
    coreStatement: '期待稳定且凝聚力强的工作，友善且融洽的交际圈',
  },
  AC: {
    desc: 'AC型 (Adhocracy&Clan) - 探索合作型',
    briefDesc: '探索合作型',
    keyWords: '创新、高效、和谐',
    coreStatement: '专业与效率同行，期待灵活的工作安排',
  },
  AM: {
    desc: 'AM型 (Adhocracy&Market) - 开拓交际型',
    briefDesc: '开拓交际型',
    keyWords: '创造力、应变力、专业性',
    coreStatement: '高效且专业的工作能力',
  },
  MA: {
    desc: 'MA型 (Market&Adhocracy) - 行动专业派',
    briefDesc: '行动专业派',
    keyWords: '冒险、快节奏、开拓',
    coreStatement: '擅长以专业的方法达成任务目标',
  },
  MH: {
    desc: 'MH型 (Market&Hierarchy) - 精细拓展型',
    briefDesc: '精细拓展型',
    keyWords: '严谨、挑战、组织',
    coreStatement: '灵活应对、及时处理工作中的各种问题',
  },
  HC: {
    desc: 'HC型 (Hierarchy&Clan) - 精细协作型',
    briefDesc: '精细协作型',
    keyWords: '责任、合作、精细',
    coreStatement: '期待明确的奖惩体系、友善的工作氛围',
  },
  HM: {
    desc: 'HM型 (Hierarchy&Market) - 合规开拓型',
    briefDesc: '合规开拓型',
    keyWords: '严谨、开拓、信心',
    coreStatement: '以规章制度与客户需求为先完成工作目标',
  },
  CA: {
    desc: 'CA型 (Clan&Adhocracy) - 温情开拓型',
    briefDesc: '温情开拓型',
    keyWords: '信任、舒适、支持',
    coreStatement: '工作方式专业性强、团队精神',
  },
  CH: {
    desc: 'CH型 (Clan&Hierarchy) - 稳定严谨型',
    briefDesc: '稳定严谨型',
    keyWords: '稳定、包容、友善',
    coreStatement: '团队精神、按部就班的执行力',
  },
  ACH: {
    desc: 'ACH型 (Adhocracy&Clan&Hierarchy) - 专业细节控',
    briefDesc: '专业细节控',
    keyWords: '专业、合作、严谨',
    coreStatement: '严谨的工作态度、效率与细节并行',
  },
  AMH: {
    desc: 'AMH型 (Adhocracy&Market&Hierarchy) - 方向把控型',
    briefDesc: '方向把控型',
    keyWords: '创新、挑战、支持',
    coreStatement: '向往自由工作，探索难解之题',
  },
  CHM: {
    desc: 'CHM型 (Clan&Hierarchy&Market) - 稳扎实打型',
    briefDesc: '稳扎实打型',
    keyWords: '稳定、严谨、开拓',
    coreStatement: '团队精神与快速高效的执行力',
  },
  CAM: {
    desc: 'CAM型 (Clan&Adhocracy&Market) - 靠谱交际型',
    briefDesc: '靠谱交际型',
    keyWords: '合作、专业、开拓',
    coreStatement: '向往高效率、低压力的工作氛围',
  },
  HCA: {
    desc: 'HCA型 (Hierarchy&Clan&Adhocracy) - 合规协作型',
    briefDesc: '合规协作型',
    keyWords: '流程化、合作、专业',
    coreStatement: '规范且专业的工作执行',
  },
  HMA: {
    desc: 'HMA型 (Hierarchy&Market&Adhocracy) - 严谨开拓型',
    briefDesc: '严谨开拓型',
    keyWords: '严谨、创新、开拓',
    coreStatement: '工作中一丝不苟的态度',
  },
  MAC: {
    desc: 'MAC型 (Market&Adhocracy&Clan) - 角逐奋进型',
    briefDesc: '角逐奋进型',
    keyWords: '竞争、创新、合作',
    coreStatement: '环境适应能力强、专业技巧掌握扎实',
  },
  MHC: {
    desc: 'MHC型 (Market&Hierarchy&Clan) - 市场掌控型',
    briefDesc: '市场掌控型',
    keyWords: '挑战、信心、稳定',
    coreStatement: '高情商、强学习能力、善于挑战新事物',
  },
};

export const getPreferenceInfo = (
  preference: number[][],
  role = 'jobseeker',
) => {
  if (preference?.length === 0) {
    return {
      desc: '完善文化偏好',
      tips: ['5分钟完善你的文化偏好，提高下一次机会的匹配成功率'],
      icon: NoResultIcon,
      result: null,
    };
  }
  const mode = getCulturePreferenceResult(preference)._teamTypePreference;
  const score = getCulturePreferenceResult(preference)._teamTypePreferenceScore;
  if (!mode) {
    return {
      desc: '未知类型',
      tips: NONE_TEAM_TYPE_PREFERENCE,
      icon: NoResultIcon,
      result: mode,
    };
  }
  return {
    desc: mode in configData ? configData[mode].desc : '',
    tips:
      role === 'jobseeker'
        ? mode in JOB_SEEKER_PREFERENCE(score) &&
          mode in JOB_SEEKER_TEAM_MODULE_SENTENCE
          ? JOB_SEEKER_PREFERENCE(score)[mode].map(
              (item, index) =>
                JOB_SEEKER_MODULE_SENTENCE(item, mode)[
                  JOB_SEEKER_TEAM_MODULE_SENTENCE[mode][index]
                ],
            )
          : NONE_TEAM_TYPE_PREFERENCE
        : mode in EMPLOYER_PREFERENCE(score) &&
            mode in EMPLOYER_TEAM_MODULE_SENTENCE
          ? EMPLOYER_PREFERENCE(score)[mode].map(
              (item, index) =>
                EMPLOYER_MODULE_SENTENCE(item, mode)[
                  EMPLOYER_TEAM_MODULE_SENTENCE[mode][index]
                ],
            )
          : NONE_TEAM_TYPE_PREFERENCE,
    icon: mode in configData ? configData[mode[0]].icon : NoResultIcon,
    result: mode,
  };
};

const defaultScoreObj = {
  E: 0,
  I: 0,
  F: 0,
  C: 0,
};

export const preferenceConfigData: Record<string, any> = {
  ...configData,
  A: {
    ...configData['A'],
    icon: AdhocracyBriefIcon,
    class: 'bg-green-50 text-green-900 border-green-900',
    bgColor:
      'linear-gradient(121.74deg, #E5E5E5 1.28%, #90E089 1.29%, #ECFDAB 100%)',
    briefIntro: 'A型人才：拥有极高的专业能力，对工作的独立性与灵活性有较高要求',
    listenWord:
      '我目前在一家外企工作，工作时间灵活，可以选择性远程办公。我的工作对专业性要求比较高，同事在各自的领域也都很专业。平时同事间关系友善且独立，我很喜欢这种具有成长性和挑战性的工作。',
  },
  M: {
    ...configData['M'],
    icon: MarketBriefIcon,
    class: 'bg-blue-50 text-blue-800 border-blue-800',
    bgColor: 'linear-gradient(123.5deg, #96ECDF -6.58%, #6490D4 118.94%)',
    briefIntro: 'M型人才：高情商与高抗压能力并存，信奉多劳多得的理念',
    listenWord:
      '我现在是一个普普通通的销售，虽有着沉重的业绩压力，我也乐在其中。多劳多得，销售的奖励和提成还是很可观的一部分收入，同时我还在这份工作中得到了自我的快速提升，无论是抗压能力还是与人沟通，与以往相比都有显著成长。',
  },
  H: {
    ...configData['H'],
    icon: HierarchyBriefIcon,
    class: 'bg-red-50 text-red-800 border-red-800',
    bgColor: 'linear-gradient(121.44deg, #F5C144 -22.49%, #EF5F92 115.71%)',

    briefIntro:
      'H型人才：拥有严谨且细致的工作态度，对自己的工作目标有清晰的管理与定位',
    listenWord:
      '我目前在某大厂的业务部门，追求完美是我们的极限，万万不可出错，严谨的工作态度是每一个同事必备的品质，一道审批十几个流程也是常事，上下班打卡更是习以为常～虽然加班时家常便饭，但是福利补贴多多哈哈。',
  },
  C: {
    ...configData['C'],
    icon: ClanBriefIcon,
    class: 'bg-yellow-50 text-yellow-900 border-yellow-900',
    bgColor: 'linear-gradient(121.74deg, #F8D377 30.59%, #E7BF31 86.12%)',
    briefIntro:
      'C型人才：对工作团队有强烈的归属感，期待拥有稳定的工作及人际关系',
    listenWord:
      '我现在在一家较大型的公司工作，所属团队中每个人都有着共同的目标，劲儿往一处使，日常同事间关系融洽，虽然发展有限，但我这种社牛的性格真是太喜欢这里了！',
  },
};

export const getBriefPreferenceInfo = (mode: string | null) => {
  if (mode && mode in configData) {
    const briefDesc = preferenceConfigData[mode].briefDesc;
    return {
      briefDesc: briefDesc ? briefDesc : preferenceConfigData[mode].desc,
      desc: preferenceConfigData[mode].desc,
      icon: preferenceConfigData[mode[0]].icon,
      className: preferenceConfigData[mode[0]].class,
      bgColor: preferenceConfigData[mode[0]].bgColor,
      briefIntro: preferenceConfigData[mode[0]].briefIntro,
      listenWord: preferenceConfigData[mode[0]].listenWord,
    };
  }
  return null;
};

export const getPreference = (mode: string | null) => {
  if (mode && mode in configData) {
    const data = configData[mode];
    return {
      desc: data.desc,
      briefDesc: data.briefDesc,
      keyWords: data.keyWords,
      coreStatement: data.coreStatement,
      mode,
    };
  }
  return undefined;
};

export const validatorData = (
  data: number[][],
  text: { title: string; options: string[] }[],
) => {
  let flag = false;
  if (data.length === text.length && text.length > 0) {
    for (const index in data) {
      const options = data[index];
      const textOptions = text[index].options;
      const optionsLength = options.length;
      const zeroNumbers = options.filter((item) => item === 0).length;
      const oneNumbers = options.filter((item) => item === 1).length;
      if (
        optionsLength === textOptions.length &&
        optionsLength > 0 &&
        (zeroNumbers === optionsLength ||
          (zeroNumbers === 1 && oneNumbers === 1))
      ) {
        flag = true;
      } else {
        flag = false;
        break;
      }
    }
  }
  return flag;
};

export const getLocalStorageData = () => {
  const storageData = getLocalStorage(STORAGE_NAME);
  const culturePreferenceData = storageData ? JSON.parse(storageData) : null;
  const handleValidate = (value: number[][]) => {
    const validValue = value.filter(
      (item) => item.includes(1) && item.includes(0),
    );
    return validValue.length === value.length;
  };
  const isValidData =
    culturePreferenceData &&
    validatorData(culturePreferenceData, CULTURE_PREFERENCE_TEXT) &&
    handleValidate(culturePreferenceData);
  if (isValidData) {
    const { _teamTypePreference, _teamTypePreferenceScore } =
      getCulturePreferenceResult(culturePreferenceData);
    return {
      [CULTURE_PREFERENCE_CHOICES]: culturePreferenceData,
      [CULTURE_PREFERENCE_TYPE]: _teamTypePreference,
      [CULTURE_PREFERENCE_SCORE]: _teamTypePreferenceScore,
    };
  }
  return null;
};

export const updateJobSeekerData = async () => {
  const culturePreferenceData = getLocalStorageData();
  if (culturePreferenceData) {
    const _submittedData: any = {
      [CULTURE_PREFERENCE]: {
        [CULTURE_PREFERENCE_CHOICES]:
          culturePreferenceData[CULTURE_PREFERENCE_CHOICES],
        [CULTURE_PREFERENCE_TYPE]:
          culturePreferenceData[CULTURE_PREFERENCE_TYPE],
        [CULTURE_PREFERENCE_SCORE]:
          culturePreferenceData[CULTURE_PREFERENCE_SCORE],
      },
    };
    const response = await updateJobSeekerProfile(_submittedData);
    if (response.status === 200) {
      removeLocalStorage(STORAGE_NAME);
      return true;
    }
    return false;
  }
  return false;
};
